import * as React from 'react';

import { ActionIcon, Button, Grid, Group, Stack, Title, Tooltip, useMantineTheme } from '@mantine/core';
import { useDisclosure } from '@mantine/hooks';
import { IconInfoCircleFilled } from '@tabler/icons-react';

import CreateStaffAvailabilityExceptionModal from './CreateStaffAvailabilityExceptionModal';
import StaffAvailabilityExceptionList from './StaffAvailabilityExceptionList';

const Exceptions = ({ isWeeklyScheduleEditable }: { isWeeklyScheduleEditable: boolean }): JSX.Element => {
  const theme = useMantineTheme();
  const [isCreateModalOpened, { open, close }] = useDisclosure(false);

  return (
    <Grid.Col span={1}>
      <Stack>
        <Group
          align='center'
          position='apart'
          p='md'
          sx={{ borderBottom: `1px solid ${theme.colors.gray[3]}` }}
        >
          <Title order={2}>Exceptions</Title>
        </Group>

        <Stack m='xl' p='xl' spacing='xl'>
          <Group>
            <Button onClick={open} disabled={isWeeklyScheduleEditable}>
              Add Date & Time
            </Button>
          </Group>

          <Group>
            <Title order={3}>Exception Slots</Title>

            <Tooltip label='Customize your schedule for specific dates. You can override your regular weekly hours by marking availability or unavailability for selected dates.'>
              <ActionIcon color='kiloBlue'>
                <IconInfoCircleFilled size={theme.fontSizes.xl} />
              </ActionIcon>
            </Tooltip>
          </Group>

          <StaffAvailabilityExceptionList />
        </Stack>
      </Stack>

      <CreateStaffAvailabilityExceptionModal opened={isCreateModalOpened} handleClose={close} />
    </Grid.Col>
  );
};

export default Exceptions;
